import { Component, Input, ViewChildren, QueryList, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrl: './otp-input.component.scss'
})
export class OtpInputComponent implements OnInit, AfterViewInit {
  @Input({ required: true }) contorl: FormControl;
  /** Number of digits (4 or 6). Default 4 for backward compatibility (e.g. forgot-password). */
  @Input() digits = 4;

  @ViewChildren('otpBox') otpBoxes!: QueryList<ElementRef<HTMLInputElement>>;

  isInvalid() {
    return false;
  }

  values: string[] = [];

  ngOnInit(): void {
    this.values = Array(this.digits).fill('');
  }

  ngAfterViewInit(): void {}

  /** تركيز المؤشر على أول خانة (يُستدعى من الأب عند ظهور حقل الإدخال). */
  focusFirst(): void {
    setTimeout(() => this.otpBoxes?.get(0)?.nativeElement?.focus(), 0);
  }

  trackByIndex(_: number, index: number): number {
    return index;
  }

  get digitIndices(): number[] {
    return Array.from({ length: this.digits }, (_, i) => i);
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const val = input.value.replace(/\D/g, '').slice(0, 1);
    this.values[index] = val;
    if (val && index < this.digits - 1) {
      const next = this.otpBoxes?.get(index + 1);
      next?.nativeElement?.focus();
    }
    this.updateFormControlValue();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    // Allow: backspace, delete, tab, escape, enter, home, end, and arrow keys
    const allowedKeys = [8, 9, 27, 13, 35, 36, 37, 38, 39, 40, 46]; // Backspace=8, Tab=9, Escape=27, Enter=13, Home=35, End=36, Arrows=37-40, Delete=46
    if (allowedKeys.includes(event.keyCode)) {
      return;
    }
    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((event.ctrlKey || event.metaKey) && [65, 67, 86, 88].includes(event.keyCode)) {
      return;
    }
    // Ensure that it is a number (0-9) - allow both main keyboard and numpad
    const isNumber = (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105);
    if (!isNumber) {
      event.preventDefault();
    }
  }

  onBackspace(event: KeyboardEvent, index: number) {
    if (event.key !== 'Backspace') return;
    if (this.values[index] === '' && index > 0) {
      const prev = this.otpBoxes?.get(index - 1);
      prev?.nativeElement?.focus();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digitChars = pastedData.replace(/\D/g, '').slice(0, this.digits);
    for (let i = 0; i < this.digits; i++) {
      this.values[i] = digitChars[i] || '';
    }
    const lastFilled = Math.min(digitChars.length, this.digits) - 1;
    if (lastFilled >= 0) {
      setTimeout(() => this.otpBoxes?.get(lastFilled)?.nativeElement?.focus(), 0);
    }
    this.updateFormControlValue();
  }

  private updateFormControlValue() {
    this.contorl.setValue(this.values.join(''));
    this.contorl.updateValueAndValidity();
  }
}
